import { Component, Input, ElementRef, Optional, Self } from '@angular/core';
import { Observable } from 'rxjs';
import { Results, PlatformApiService, ResultFilter } from '../services/platform-api.service';
import { Account } from '../models/AccountModel';
import { InfiniteScrollSelectComponent, InfiniteScrollOption } from './infinite-scroll-select.component';
import { MatFormFieldControl } from '@angular/material/form-field';
import { FocusMonitor } from '@angular/cdk/a11y';
import { NgControl } from '@angular/forms';

@Component({
  selector: 'cw-automate-client-dropdown',
  templateUrl: './infinite-scroll-select.component.html',
  styleUrls: ['./infinite-scroll-select.component.scss'],
  providers:[{provide: MatFormFieldControl, useExisting: AutomateClientDropdownComponent}]
})
export class AutomateClientDropdownComponent extends InfiniteScrollSelectComponent<number> {
  @Input() placeholder = 'Automate Client'
  @Input() partnerAccount:Account;
  @Input() disableInUseClients: boolean;
  @Input() MultiSelection: string;
  selectedValue: any[] = [];
  _account: Account;

  constructor(private _apiService: PlatformApiService, fm: FocusMonitor, elRef: ElementRef<HTMLElement>,
    @Optional() @Self() ngControl: NgControl) {
    super(fm, elRef, ngControl);
  }

  searchFunction(currentFilters: ResultFilter) : Observable<Results<any>> {
    return this._apiService.getAutomateClients(this.partnerAccount.id, currentFilters);
  }

  mapSearchResults(results: Results<any>) {
    if(results.count > 0) {
      this.options.next(results.results.map(result => {
        return new InfiniteScrollOption(result.Name, result.Id, this.disableInUseClients ? result.mappedToIdentify : false, false, true);
      }));
    } else {
      this.options.next([new InfiniteScrollOption('No results found.', null, true, false, true)]);
    }
    this.totalResults = results.count;
  }

  createResultsFilter(filter: string) {
    const resultFilter = new ResultFilter();
    resultFilter.searchData.name = filter;
    return resultFilter;
  }

  optionClicked(event: Event, option) {
    event.stopPropagation();
  }

  toggleSelection(option) {}
}